import React from 'react';
import { Link } from 'react-router-dom';

const IndustriesLinkSection = () => {
  return (
    <section style={{
      backgroundColor: '#242423',
      borderTop: '1px solid #3A3A38',
      padding: '48px 16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <div style={{
        maxWidth: '1200px',
        width: '100%',
        textAlign: 'center'
      }}>
        {/* Description Text */}
        <p style={{
          color: '#9CA3AF',
          fontSize: '18px',
          lineHeight: '1.6',
          marginBottom: '24px'
        }}>
          These capabilities power orchestration across manufacturing, automotive, maritime, and defense environments.
        </p>
        
        {/* Link to Use Cases */}
        <Link 
          to="/use-cases"
          style={{
            color: '#4FB3B8',
            fontSize: '16px',
            fontWeight: '500',
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
        >
          See how teams apply Sleeve across industries
          <span style={{ fontSize: '20px' }}>→</span>
        </Link>
      </div>
    </section>
  );
};

export default IndustriesLinkSection;